module.exports = __webpack_public_path__ + "static/media/Coin_Icon.7b0b195b.png";